// Which entry point sent the user to the Templates panel. Read when a template fills the current
// board, so analytics can tell a modal pick apart from a blank-canvas pick.
import { TEMPLATES_SLIDERS_ID } from '@/js/shared/sidepanel';

const ATTRIBUTE = 'data-template-source';

export const MODAL_SOURCE = 'start_from_template_modal';
export const BLANK_CANVAS_SOURCE = 'blank_canvas';

export const markTemplateSource = (source) => {
  document.getElementById(TEMPLATES_SLIDERS_ID)?.setAttribute(ATTRIBUTE, source);
};

export const templateSource = () =>
  document.getElementById(TEMPLATES_SLIDERS_ID)?.getAttribute(ATTRIBUTE) || BLANK_CANVAS_SOURCE;
